/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  FixedPointMathLib,
  FixedPointMathLibInterface,
} from "../FixedPointMathLib";

const _abi = [
  {
    inputs: [],
    name: "DivFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "DivWadFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "ExpOverflow",
    type: "error",
  },
  {
    inputs: [],
    name: "FactorialOverflow",
    type: "error",
  },
  {
    inputs: [],
    name: "FullMulDivFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "LnWadUndefined",
    type: "error",
  },
  {
    inputs: [],
    name: "MantissaOverflow",
    type: "error",
  },
  {
    inputs: [],
    name: "MulDivFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "MulWadFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "OutOfDomain",
    type: "error",
  },
  {
    inputs: [],
    name: "RPowOverflow",
    type: "error",
  },
  {
    inputs: [],
    name: "SDivWadFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "SMulWadFailed",
    type: "error",
  },
] as const;

export class FixedPointMathLib__factory {
  static readonly abi = _abi;
  static createInterface(): FixedPointMathLibInterface {
    return new Interface(_abi) as FixedPointMathLibInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): FixedPointMathLib {
    return new Contract(address, _abi, runner) as unknown as FixedPointMathLib;
  }
}
